<template>
    <section class="dp-layout">
        <section class="dp-left">
            <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
        </section>
        <section class="dp-right lsm-page">
            <header class="lsm-page-head">
                <h2 class="lsm-page-title">菜单信息显隐控制</h2>
                <div class="lsm-page-actions" v-if="DepartmentId > 0">
                    <el-button type="primary" size="small" @click="handleSave" :loading="saving">保存配置</el-button>
                </div>
            </header>

            <div class="lsm-page-body" v-loading="configLoading">
                <div class="lsm-menu-grid" v-if="DepartmentId > 0">
                    <div class="menu-board-card" v-for="(module, index) in menuModules" :key="index">
                        <div class="board-header">
                            <div class="icon-wrap" :style="{ background: module.colorBg }">
                                <i :class="module.icon" :style="{ color: module.colorText }"></i>
                            </div>
                            <h3 class="board-title">{{ module.title }}</h3>
                            <el-switch v-model="module.allEnabled" class="master-switch"
                                @change="(val) => handleMasterSwitch(module, val)">
                            </el-switch>
                        </div>

                        <el-divider class="board-divider"></el-divider>

                        <ul class="switch-list">
                            <li class="switch-item" v-for="(item, iIndex) in module.items" :key="iIndex">
                                <span class="item-name">{{ item.name }}</span>
                                <el-switch v-model="item.visible" active-color="#13ce66"
                                    inactive-color="#dcdfe6"></el-switch>
                            </li>
                        </ul>
                    </div>
                </div>

                <!-- 未选择部门时的提示 -->
                <div v-else class="lsm-empty-tip">
                    <p>请选择左侧的学校或部门来查看和配置大屏菜单信息</p>
                </div>
            </div>
        </section>
    </section>
</template>

<script>
import DepartmentPane from '../../components/DepartmentPane'
import { saveMenuScreenConfig, getMenuScreenConfig } from '../../api/modules/big-screen';
export default {
    name: 'MenuInfoManage',
    components: { DepartmentPane },
    data() {
        return {
            DepartmentId: 0,
            saving: false,
            configLoading: false,
            menuModules: [
                {
                    title: '学校画像',
                    icon: 'el-icon-school',
                    colorBg: 'rgba(64, 158, 255, 0.1)',
                    colorText: '#2563eb',
                    allEnabled: true,
                    items: [
                        { name: '组织架构', visible: true },
                        { name: '校园概况', visible: true },
                        { name: '校园风采', visible: true },
                    ]
                },
                {
                    title: '教师画像',
                    icon: 'el-icon-s-custom',
                    colorBg: 'rgba(103, 194, 58, 0.1)',
                    colorText: '#67C23A',
                    allEnabled: true,
                    items: [
                        { name: '教师概况', visible: true },
                        { name: '分级对比', visible: true },
                        { name: '名特优', visible: true },
                        { name: '教师光荣榜', visible: true },
                        { name: '教师形象墙', visible: true }
                    ]
                },
                {
                    title: '综合展示',
                    icon: 'el-icon-s-data',
                    colorBg: 'rgba(230, 162, 60, 0.1)',
                    colorText: '#E6A23C',
                    allEnabled: true,
                    items: [
                        { name: '校园新风', visible: true },
                        { name: '校园动态', visible: true },
                        { name: '教师成长', visible: true },
                        { name: '学生成长', visible: true }
                    ]
                },
                {
                    title: '班级画像',
                    icon: 'el-icon-s-home',
                    colorBg: 'rgba(245, 108, 108, 0.1)',
                    colorText: '#F56C6C',
                    allEnabled: true,
                    items: [
                        { name: '班级风采', visible: true },
                        { name: '班级荣誉', visible: false },
                        { name: '值周评分', visible: false }
                    ]
                },
                {
                    title: '学生画像',
                    icon: 'el-icon-user',
                    colorBg: 'rgba(142, 113, 199, 0.1)',
                    colorText: '#8e71c7',
                    allEnabled: true,
                    items: [
                        { name: '综合素质', visible: false },
                        { name: '点评榜单', visible: true },
                        { name: '协约之星', visible: true },
                        { name: '学生笑脸墙', visible: false }
                    ]
                }
            ]
        }
    },
    created() {
        this.GetMenuConfig();
    },
    watch: {
        // 监听子项变化以更新全选状态
        menuModules: {
            handler(val) {
                val.forEach(module => {
                    const allTrue = module.items.every(item => item.visible);
                    module.allEnabled = allTrue;
                });
            },
            deep: true
        }
    },
    methods: {
        treeNodeClick(data, node, component) {
            this.DepartmentId = data.value;
            this.GetMenuConfig();
        },
        async GetMenuConfig() {
            if (!this.DepartmentId) return;
            this.configLoading = true;
            const res = await getMenuScreenConfig({
                departmentId: this.DepartmentId
            });
            if (res.data.success && res.data.response && res.data.response.MenuInfoDisplayConfig) {
                try {
                    const savedConfig = JSON.parse(res.data.response.MenuInfoDisplayConfig);
                    if (savedConfig && Array.isArray(savedConfig)) {
                        // 将后端返回的数据与前端默认数据合并，避免新增子项时前端报错
                        this.menuModules = this.menuModules.map(module => {
                            const savedModule = savedConfig.find(m => m.title === module.title);
                            if (savedModule) {
                                // 更新子项
                                module.items = module.items.map(item => {
                                    const savedItem = savedModule.items.find(i => i.name === item.name);
                                    if (savedItem) {
                                        item.visible = savedItem.visible;
                                    }
                                    return item;
                                });
                                module.allEnabled = module.items.every(item => item.visible);
                            }
                            return module;
                        });
                    }
                } catch (e) {
                    console.error('Failed to parse menu config', e);
                }
            } else {
                // 初始化时根据子项可见性同步每个模块的全选开关状态 (默认状态)
                this.menuModules.forEach(module => {
                    module.allEnabled = module.items.every(item => item.visible);
                });
            }
            this.configLoading = false;
        },
        handleMasterSwitch(module, val) {
            module.items.forEach(item => {
                item.visible = val;
            });
        },
        async handleSave() {
            if (!this.DepartmentId) {
                this.$message.warning('请先选择左侧部门');
                return;
            }
            this.saving = true;
            try {
                const configString = JSON.stringify(this.menuModules);
                const res = await saveMenuScreenConfig({
                    MenuInfoDisplayConfig: configString,
                    SchoolId: this.DepartmentId
                });
                if (res.data.success) {
                    this.$message.success('菜单配置保存成功');
                } else {
                    this.$message.error(res.Msg || '保存失败');
                }
            } catch (error) {
                this.$message.error('保存出错');
            } finally {
                this.saving = false;
            }
        }
    }
}
</script>

<style src="../../style/large-screen-manage.css"></style>
<style scoped>
.menu-board-card {
    background: #ffffff;
    border-radius: 10px;
    padding: 14px 16px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    border: 1px solid #eef0f6;
    box-sizing: border-box;
}

.board-header {
    display: flex;
    align-items: center;
    position: relative;
}

.icon-wrap {
    width: 34px;
    height: 34px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
}

.icon-wrap i {
    font-size: 16px;
}

.board-title {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    color: #2c3e50;
    flex: 1;
}

.master-switch {
    margin-left: auto;
}

.board-divider {
    margin: 10px 0;
    background-color: #f0f2f5;
}

/* 开关项列表：更紧凑 */
.switch-list {
    list-style: none;
    padding: 0;
    margin: 0;
}

/* 防止 flex 子项内内容超出导致的横向滚动 */
.board-header,
.switch-item,
.switch-list,
.board-title {
    min-width: 0;
}

.switch-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    border-radius: 6px;
    transition: background-color 0.15s;
    margin-bottom: 2px;
}

.switch-item:hover {
    background-color: #f8fafc;
}



.item-name {
    font-size: 13px;
    color: #606266;
    font-weight: 500;
}
</style>
